import { generateUUID } from 'shared/helpers/utils/generate-uuid';
import { TableFilterFieldType } from 'common/TableFilter';
import type { TableFilterField } from 'common/TableFilter';

export const roomsFilterFields: TableFilterField[] = [
  {
    key: generateUUID(),
    name: 'number',
    label: 'Номер аудитории',
    type: TableFilterFieldType.NUMBER,
    min: 0,
    precision: 0,
  },
  {
    key: generateUUID(),
    name: 'name',
    label: 'Наименование аудитории',
    type: TableFilterFieldType.INPUT,
  },
];
